<template>
  <div>
    <div>
      <p class="mb-8 font-mono font-bold text-grey-chateau">Step 1</p>
      <h1 class="mb-40 text-5xl font-light text-tangaroa leading-loose">
        Pick Your Dataset
      </h1>
      <h2 class="mb-16 text-lg font-semibold">Sample Index Data</h2>
      <p class="mb-16">
        Algolia will search through any set of data, as long as it’s structured.
        This is what we call an index.
      </p>
      <p class="mb-40">
        The items are broken down into individual records (objects), with each
        object containing a set of fields (attributes).
      </p>
      <h2 class="mb-16 text-lg font-semibold">About Algolia</h2>
      <p class="mb-40">
        Algolia is a hosted search API that provides online companies with the
        resources &amp; tools they need to create fast, relevant search.
      </p>
      <h2 class="mb-16 text-lg font-semibold">Learn More</h2>
      <ul class="mb-40">
        <li>
          <a
            class="text-link"
            target="_blank"
            href="https://www.algolia.com/doc/guides/getting-started/what-is-algolia/"
            >What is Algolia?</a
          >
        </li>
      </ul>
    </div>
    <div class="flex">
      <div class="w-40 mr-16 flex-no-shrink flex-no-grow">
        <smartphone />
      </div>
      <div>
        <p class="text-lg font-semibold mb-8">
          Developing for native platforms?
        </p>
        <p>
          Learn how to integrate Algolia into
          <a
            class="text-link"
            target="_blank"
            href="https://www.algolia.com/doc/tutorials/getting-started/quick-start-with-the-api-client/swift/"
            @click="
              track({
                message: 'Clicked Learn Algolia',
                extraData: { cta: 'iOS' },
                code: 'docs.onboarding.learn.ios'
              })
            "
            >iOS</a
          >,
          <a
            class="text-link"
            target="_blank"
            href="https://www.algolia.com/doc/tutorials/getting-started/quick-start-with-the-api-client/android/"
            @click="
              track({
                message: 'Clicked Learn Algolia',
                extraData: { cta: 'android' },
                code: 'docs.onboarding.learn.android'
              })
            "
            >Android</a
          >
          or
          <a
            class="text-link"
            target="_blank"
            rel="noopener"
            href="https://www.algolia.com/doc/guides/building-search-ui/going-further/native/react/"
            @click="
              track({
                message: 'Clicked Learn Algolia',
                extraData: { cta: 'react native' },
                code: 'docs.onboarding.learn.react.native'
              })
            "
            >React Native</a
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Smartphone from '@/assets/images/smartphone.svg'
import track from '@/scripts/Track'

export default {
  components: { Smartphone },
  methods: { track }
}
</script>
